/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/JiraBusinessFormBuilderAppMemoQuery$parameters.ts';
import type { JiraBusinessFormBuilderAppMemoQuery } from './__generated__/JiraBusinessFormBuilderAppMemoQuery.graphql.ts';

type FormBuilderEntrypointComponent = EntryPointComponent<
	{
		formBuilderQuery: JiraBusinessFormBuilderAppMemoQuery;
	},
	{},
	{},
	{}
>;

export const formBuilderEntrypoint: EntryPoint<
	FormBuilderEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<FormBuilderEntrypointComponent>(
		/* webpackChunkName: "async-business-form-builder-entrypoint" */ './JiraBusinessFormBuilderAppMemo.tsx',
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey;

		if (projectKey == null) {
			throw new Error('Project key missing');
		}

		return {
			queries: {
				formBuilderQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						projectKey,
					},
				},
			},
		};
	},
});
